import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("js_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return null;
    }
    try {
      const response = await api.get("/auth/me");
      setUser(response.data);
      return response.data;
    } catch {
      localStorage.removeItem("js_token");
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    const onUnauthorized = () => {
      localStorage.removeItem("js_token");
      setUser(null);
    };
    window.addEventListener("js-unauthorized", onUnauthorized);
    return () => window.removeEventListener("js-unauthorized", onUnauthorized);
  }, []);

  const acceptSession = (payload) => {
    localStorage.setItem("js_token", payload.token);
    setUser(payload.user);
    setLoading(false);
  };

  const signOut = () => {
    localStorage.removeItem("js_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, refresh, acceptSession, signOut, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
